import { DefaultState } from '@src/redux/types'

import * as ActionTypes from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [ActionTypes.STC]: DefaultState<`/${typeof API.STC}{id}`, 'get'>
  [ActionTypes.STC_ADMIN]: DefaultState<`/${typeof API.STC_ADMIN}{id}`, 'get'>
  [ActionTypes.STC_LIST]: DefaultState<`/${typeof API.STC}`, 'get'>
  [ActionTypes.STC_ALL]: DefaultState<`/${typeof API.STC_ALL}`, 'get'>
  [ActionTypes.STC_CREATE]: DefaultState<`/${typeof API.STC}`, 'post'>
  [ActionTypes.STC_CATEGORY]: DefaultState<`/${typeof API.STC_CATEGORY}{id}`, 'get'>
  [ActionTypes.STC_CATEGORY_ALL]: DefaultState<`/${typeof API.STC_CATEGORY_ALL}`, 'get'>
  [ActionTypes.STC_CATEGORY_LIST]: DefaultState<`/${typeof API.STC_CATEGORY}`, 'get'>
  [ActionTypes.STC_CATEGORY_CREATE]: DefaultState<`/${typeof API.STC_CATEGORY}`, 'post'>
  [ActionTypes.STC_CATEGORY_DELETE]: DefaultState<`/${typeof API.STC_CATEGORY}{id}`, 'delete'>

  [ActionTypes.STC_STEP]: DefaultState<`/${typeof API.STC_STEP}{id}`, 'get'>
  [ActionTypes.STC_STEP_ALL]: DefaultState<`/${typeof API.STC_STEP_ALL}`, 'get'>
  [ActionTypes.STC_STEP_ADMIN_ALL]: DefaultState<`/${typeof API.STC_STEP_ADMIN_ALL}`, 'get'>
  [ActionTypes.STC_STEP_COMPLETE]: DefaultState<`/${typeof API.STC_STEP_COMPLETE}`, 'post'>
  [ActionTypes.STC_STEP_CREATE]: DefaultState<`/${typeof API.STC_STEP}`, 'post'>
  [ActionTypes.STC_STEP_LIST]: DefaultState<`/${typeof API.STC_STEP}`, 'get'>

  [ActionTypes.STC_CHAPTER]: DefaultState<`/${typeof API.STC_CHAPTER}{id}`, 'get'>
  [ActionTypes.STC_CHAPTER_ALL]: DefaultState<`/${typeof API.STC_CHAPTER_ALL}`, 'get'>
  [ActionTypes.STC_CHAPTER_CREATE]: DefaultState<`/${typeof API.STC_CHAPTER}`, 'post'>
  [ActionTypes.STC_CHAPTER_CREATE_BATCH]: DefaultState<`/${typeof API.STC_CHAPTER_CREATE_BATCH}`, 'post'>
  [ActionTypes.STC_CHAPTER_DELETE]: DefaultState<`/${typeof API.STC_CHAPTER}{id}`, 'delete'>
  [ActionTypes.STC_CHAPTER_LIST]: DefaultState<`/${typeof API.STC_CHAPTER}`, 'get'>

  [ActionTypes.STC_TOPIC_LIST]: DefaultState<`/${typeof API.STC_TOPIC}`, 'get'>
  [ActionTypes.STC_TOPIC_ALL]: DefaultState<`/${typeof API.STC_TOPIC_ALL}`, 'get'>
  [ActionTypes.STC_TOPIC]: DefaultState<`/${typeof API.STC_TOPIC}{id}`, 'get'>
  [ActionTypes.STC_TOPIC_DELETE]: DefaultState<`/${typeof API.STC_TOPIC}{id}`, 'delete'>
  [ActionTypes.STC_TOPIC_CREATE]: DefaultState<`/${typeof API.STC_TOPIC}`, 'post'>
} = () => ({
  [ActionTypes.STC]: defaultState(),
  [ActionTypes.STC_ADMIN]: defaultState(),
  [ActionTypes.STC_LIST]: defaultState(),
  [ActionTypes.STC_ALL]: defaultState(),
  [ActionTypes.STC_CREATE]: defaultState(),
  [ActionTypes.STC_CATEGORY]: defaultState(),
  [ActionTypes.STC_CATEGORY_ALL]: defaultState(),
  [ActionTypes.STC_CATEGORY_LIST]: defaultState(),
  [ActionTypes.STC_CATEGORY_CREATE]: defaultState(),
  [ActionTypes.STC_CATEGORY_DELETE]: defaultState(),

  [ActionTypes.STC_STEP]: defaultState(),
  [ActionTypes.STC_STEP_ALL]: defaultState(),
  [ActionTypes.STC_STEP_ADMIN_ALL]: defaultState(),
  [ActionTypes.STC_STEP_COMPLETE]: defaultState(),
  [ActionTypes.STC_STEP_CREATE]: defaultState(),
  [ActionTypes.STC_STEP_LIST]: defaultState(),

  [ActionTypes.STC_CHAPTER]: defaultState(),
  [ActionTypes.STC_CHAPTER_ALL]: defaultState(),
  [ActionTypes.STC_CHAPTER_CREATE_BATCH]: defaultState(),
  [ActionTypes.STC_CHAPTER_CREATE]: defaultState(),
  [ActionTypes.STC_CHAPTER_DELETE]: defaultState(),
  [ActionTypes.STC_CHAPTER_LIST]: defaultState(),

  [ActionTypes.STC_TOPIC_LIST]: defaultState(),
  [ActionTypes.STC_TOPIC_ALL]: defaultState(),
  [ActionTypes.STC_TOPIC]: defaultState(),
  [ActionTypes.STC_TOPIC_DELETE]: defaultState(),
  [ActionTypes.STC_TOPIC_CREATE]: defaultState(),
})
